export const SITE_ACCESS_KEY = 'zl-site-access';
const SITE_ACCESS_TOKEN = '1';

/** Empty or unset REACT_APP_SITE_PASSWORD disables the gate (required for production / SEO). */
export function isPasswordGateEnabled(): boolean {
  return Boolean(process.env.REACT_APP_SITE_PASSWORD?.trim());
}

const SITE_PASSWORD = isPasswordGateEnabled()
  ? (process.env.REACT_APP_SITE_PASSWORD ?? 'slay2026')
  : '';

export function isSiteAccessGranted(): boolean {
  try {
    return sessionStorage.getItem(SITE_ACCESS_KEY) === SITE_ACCESS_TOKEN;
  } catch {
    return false;
  }
}

export function grantSiteAccess(): void {
  try {
    sessionStorage.setItem(SITE_ACCESS_KEY, SITE_ACCESS_TOKEN);
  } catch {
    /* noop */
  }
}

export function verifySitePassword(input: string): boolean {
  if (!isPasswordGateEnabled()) return true;
  return input === SITE_PASSWORD;
}
